import { render } from "./SidebarStore.vue?vue&type=template&id=2b336d06&scoped=true"
import script from "./SidebarStore.vue?vue&type=script&lang=js"
export * from "./SidebarStore.vue?vue&type=script&lang=js"

import "./SidebarStore.vue?vue&type=style&index=0&id=2b336d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b336d06"]])

export default __exports__